import React, { FC, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Trans, t } from '@lingui/macro'
import { getPromotedChannels } from 'api/schedule/getPromotedChannels'
import { getPromotedChannelsForRoot } from 'api/schedule/getPromotedChannelsForRoot'
import { TrendingChannelItem } from 'api/schedule/trendingChannel.interface'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import { Loader } from 'components/Loader/Loader'
import { ErrorMessage } from 'components/ErrorMessage/ErrorMessage'
import { ChannelList } from 'components/ChannelList/ChannelList'
// import BoletoElement from '@adyen/adyen-web/dist/types/components/Boleto'
import { useQueryDataFetcher } from 'hooks/useQueryDataFetcher/useQueryDataFetcher'

import styles from './TrendingChannels.module.scss'
interface Props {
  onTrendingChannelsExist: () => void
}
export const TrendingChannels: FC<Props> = ({ onTrendingChannelsExist }) => {
  const { company } = useParams<{ company: string | undefined }>()
  const channel = useSelector(channelSelector)

  const subdomain = channel?.data?.subdomain
  const isCurrentChannel = subdomain && subdomain === company
  const isRootChannel = isCurrentChannel && channel?.data?.isRootChannel
  const isChildOfRootChannel =
    isCurrentChannel && channel?.data?.isChildOfRootChannel
  const isRootOrChild = isRootChannel || isChildOfRootChannel

  const apiToUse = isRootOrChild
    ? () => getPromotedChannelsForRoot(subdomain)
    : () => getPromotedChannels()

  const { isLoading, isError, data } = useQueryDataFetcher<TrendingChannelItem>(
    {
      queryKey: 'TrendingChannels',
      queryFn: apiToUse
    }
  )

  useEffect(() => {
    if (data && data?.length > 0) {
      onTrendingChannelsExist()
    }
  }, [data, onTrendingChannelsExist])

  if (isLoading) return <Loader />
  if (isError)
    return (
      <ErrorMessage
        title={t`Something went wrong when trying to get the list of trending channels`}
        subText={''}
      />
    )
  if (!data || data.length === 0) return null
  return (
    <div className={styles.Container} data-testid="trending-channels-container">
      <h4>
        <Trans>Trending channels</Trans>
      </h4>
      <ChannelList list={data} isOnRootOrChildChannel={isRootOrChild} />
    </div>
  )
}
